import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { CLINIC, whatsappLink } from "../lib/clinic";

const includes = [
  "Full clinical jaw, bite & TMJ assessment",
  "Personalised plan via WhatsApp — no obligation",
  "Two-week follow-up review",
  "Direct WhatsApp line to Dr. Patel after your appointment",
  "Honest advice — only proceed if it's clinically right for you",
];

export const Pricing = () => {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="py-24 lg:py-32 bg-rb-bg-3 border-y border-rb-border"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <div className="font-overline mb-4">Transparent pricing</div>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-rb-text leading-[1.1]">
            Clear costs.
            <br />
            <span className="italic text-[#93C5FD]">No surprises.</span>
          </h2>
          <p className="mt-6 text-rb-text-2 leading-relaxed">
            We believe in transparent pricing — you'll always know exactly what
            you're paying for, and what to expect. The free consultation has
            zero obligation.
          </p>
          <div className="mt-8 grid grid-cols-2 gap-4">
            <div className="card-soft p-5">
              <div className="font-overline mb-1">Duration</div>
              <div className="font-serif-display text-2xl text-rb-text">
                {CLINIC.pricing.duration}
              </div>
            </div>
            <div className="card-soft p-5">
              <div className="font-overline mb-1">Lasts</div>
              <div className="font-serif-display text-2xl text-rb-text">
                {CLINIC.pricing.lasts}
              </div>
            </div>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-7"
          data-testid="pricing-card"
        >
          <div className="card-soft overflow-hidden shadow-[0_30px_60px_-30px_rgba(0,0,0,0.5)]">
            <div className="grid sm:grid-cols-2">
              <div className="p-8 border-b sm:border-b-0 sm:border-r border-white/10">
                <div className="font-overline mb-2">Consultation</div>
                <div className="flex items-baseline gap-2">
                  <span className="font-serif-display text-5xl text-rb-text">
                    {CLINIC.pricing.consultation}
                  </span>
                </div>
                <p className="text-sm text-rb-text-2 mt-3">
                  Honest, in-person assessment with Dr. Patel. Zero obligation.
                </p>
              </div>
              <div className="p-8 bg-white/[0.03]">
                <div className="font-overline mb-2">Bruxism Treatment</div>
                <div className="flex items-baseline gap-2">
                  <span className="font-serif-display text-5xl text-rb-text">
                    {CLINIC.pricing.treatment}
                  </span>
                </div>
                <p className="text-sm text-rb-text-2 mt-3">
                  Final price confirmed in your consultation, based on clinical need.
                </p>
              </div>
            </div>

            <div className="p-8">
              <div className="font-overline mb-4">What's included</div>
              <ul className="space-y-3">
                {includes.map((item) => (
                  <li
                    key={item}
                    className="flex items-start gap-3 text-sm text-rb-text"
                  >
                    <Check
                      size={16}
                      strokeWidth={2}
                      className="text-[#93C5FD] mt-0.5 shrink-0"
                    />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <a
                  href={whatsappLink()}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="pricing-cta-whatsapp"
                  className="btn-primary inline-flex items-center justify-center"
                >
                  Enquire on WhatsApp
                </a>
                <a
                  href={CLINIC.phoneRaw}
                  data-testid="pricing-cta-call"
                  className="btn-secondary inline-flex items-center justify-center"
                >
                  Call {CLINIC.phoneDisplay}
                </a>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
